export default __webpack_public_path__ + "static/media/wheel-pointer.8ec63390.svg";